import { ApplicationConfig } from '@angular/core';
import { PreloadAllModules, provideRouter, RouteReuseStrategy, withPreloading } from '@angular/router';
import { routes } from './app.routes';
import { importProvidersFrom } from '@angular/core';
import { TegelModule } from './shared/tegel.module';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';

import { provideHttpClient, withInterceptors } from '@angular/common/http';
// import { MSALGuardConfigFactory } from './auth/msal-guard-config';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { toastInterceptor } from './core/interceptors/toast.interceptor';
import { provideMarkdown } from 'ngx-markdown';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { CustomReuseStrategy } from './core/custom-reuse.strategy';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      routes, 
      withPreloading(PreloadAllModules)
    ),
    { provide: RouteReuseStrategy, useClass: CustomReuseStrategy },
    provideHttpClient(
      withInterceptors([authInterceptor, toastInterceptor])
    ),
    provideAnimations(), // 为 ngx-charts 等需要动画的库提供支持
    provideClientHydration(),
    importProvidersFrom(TegelModule),
    provideMarkdown(),
    importProvidersFrom(NgxExtendedPdfViewerModule),
  ],
};
